exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".UnreadCount-module__wrapper___5y7Kz{height:20px;background-color:#fc156d;border-radius:22px;color:#fff;display:flex;justify-content:center;align-items:center;font-size:14px;padding:1px .45rem 0;font-weight:700}.UnreadCount-module__wrapper___5y7Kz.UnreadCount-module__small___M53IT{font-size:12px;height:17px;padding:0 .35rem}.UnreadCount-module__wrapper___5y7Kz.UnreadCount-module__project___3k5h9,.UnreadCount-module__wrapper___5y7Kz.UnreadCount-module__small___M53IT.UnreadCount-module__project___3k5h9{background-color:#b4bac3}", ""]);

// exports
exports.locals = {
	"wrapper": "UnreadCount-module__wrapper___5y7Kz",
	"small": "UnreadCount-module__small___M53IT",
	"project": "UnreadCount-module__project___3k5h9"
};